import { PreservedText, SupportHL7Message } from '@enter/core';
import * as S from './claim-timeline-table.styles';
import React from 'react';
import { format } from 'date-fns';

interface IHL7MessageDetailProps {
    hl7Message: SupportHL7Message;
}

export const HL7MessageDetail: React.FunctionComponent<IHL7MessageDetailProps> = (
    props: IHL7MessageDetailProps,
): React.ReactElement => {
    const { hl7Message } = props;
    const message = (hl7Message.message || '').replace(/\r|\n/g, '\n');

    const renderCreated = (): string => {
        if (!hl7Message.created) {
            return '—';
        }

        try {
            return format(new Date(hl7Message.created), 'MMM dd, yyyy hh:mm a');
        } catch (error) {
            return '—';
        }
    };

    return (
        <S.ExpandContainer>
            <S.ExpandTable>
                <S.ExpandTBody>
                    <S.ExpandTR>
                        <S.ExpandTH>ID</S.ExpandTH>
                        <S.ExpandTD>{hl7Message.id || '—'}</S.ExpandTD>
                    </S.ExpandTR>
                    <S.ExpandTR>
                        <S.ExpandTH>Type</S.ExpandTH>
                        <S.ExpandTD>{hl7Message.type || '—'}</S.ExpandTD>
                    </S.ExpandTR>
                    <S.ExpandTR>
                        <S.ExpandTH>Created</S.ExpandTH>
                        <S.ExpandTD>{renderCreated()}</S.ExpandTD>
                    </S.ExpandTR>
                    <S.ExpandTR>
                        <S.ExpandTH>Payload</S.ExpandTH>
                        <S.ExpandTD>
                            <S.PayloadWrapper>{message ? <PreservedText text={message} /> : '—'}</S.PayloadWrapper>
                        </S.ExpandTD>
                    </S.ExpandTR>
                </S.ExpandTBody>
            </S.ExpandTable>
        </S.ExpandContainer>
    );
};
